import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ActiveUsers from '../ActiveUsers';
import { SettingsKeys } from '@manakin/core/dist/lib/constants';
import { SettingAccessControl } from '@manakin/core';
import { isSettingEnabled } from '@manakin/core/dist/actions';
import { ResumeButton } from '@manakin/app-core';
import renderHTML from "react-render-html";

const styles = (theme) => ({
	contentColor: {
		opacity: 1,
		transition: 'opacity .3s',
	},
	headingName: {
		[theme.breakpoints.up('md')]: {
			display: 'block',
		},
	},
	root: {
		width: '100%',
		minHeight: '500px',
		height: 'auto',
		backgroundColor: theme.manakin.primaryColor[500],
		padding: '20rem 0 50rem',
		'& $contentColor': {
			color: theme.palette.getContrastText(theme.manakin.primaryColor[500]),
		},
		[theme.breakpoints.up('md')]: {
			padding: '18rem 0 50rem',
		},
	},
	wrapper: {
		...theme.manakin.defaultWrapper,
	},
	resumeWrapper: {
		...theme.manakin.defaultWrapper,
		textAlign: 'right',
		paddingBottom: '3rem',
		paddingLeft: 37,
		paddingRight: 37,
		maxWidth: 1230,
		[theme.breakpoints.up('md')]: {
			paddingBottom: '4.8rem',
		},
	},
	content: {
		[theme.breakpoints.up('md')]: {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			marginBottom: '2.3rem',
		},
	},
	title: {
		[theme.breakpoints.up('md')]: {
			maxWidth: '410px',
			width: '100%',
			padding: '2rem 0',
		},
	},
	heading: {},
	body: {
		marginBottom: '2.8rem',
		"& ol, ul" : {
			listStyle: "inside"
		}
	},
	introduction: {
		[theme.breakpoints.up('md')]: {
			maxWidth: '450px',
			width: '100%',
		},
	},
	loading: {
		opacity: 0,
	},
});

const Header = (props) => {
	const { classes, user, data, loading, config = {}, children, resume, showNextButton = true, description = '' } = props;
	const { t } = useTranslation();

	const showActiveUsersProfilePicture = isSettingEnabled(SettingsKeys.SHOW_ACTIVE_USERS_PROFILE_PICTURE)

	const { pages } = config;
	const appDashboardConfig = pages.appDashboard || {};
	const showName = appDashboardConfig.showName != undefined ? appDashboardConfig.showName : true;

	return (
		<React.Fragment>
			<SettingAccessControl name={SettingsKeys.SHOW_ACTIVE_USERS}>
				<ActiveUsers showProfilePictures={showActiveUsersProfilePicture} />
			</SettingAccessControl>
			<div className={classes.root}>
				<div className={classes.wrapper}>
					<div className={classes.content}>
						<div className={classes.title}>
							<Typography component="h1" variant="h2" className={classes.contentColor} classes={{ h2: classes.heading }}>
								{t('app.dashboard.title')} <span className={classes.headingName}>{(showName && user.firstName) || ''}</span>
							</Typography>
						</div>
						<div className={classes.introduction}>
							<Typography
								component="p"
								variant="body2"
								classes={{ body2: classes.body }}
								className={classNames(classes.contentColor, {
									[classes.loading]: loading,
								})}
							>
								{renderHTML(description || data.description || '')}
							</Typography>
						</div>
					</div>
					{children}
				</div>
				{resume && showNextButton && (
				<div className={classes.resumeWrapper}>
					<ResumeButton {...resume} />
				</div>
				)}
			</div>
		</React.Fragment>
	);
};

export default compose(
	withStyles(styles, { name: 'AppDashboardHeader' }),
	connect(({ config }) => ({ config }))
)(Header);
